import Typography from '@mui/material/Typography';
import SelectField from '../../../../../FormControl/input/SelectField';
import { Checkbox, Divider, FormControlLabel, Tooltip } from '@mui/material';
import SelectCurriculum from '../../SelectCustom/SelectCurriculum';
import { setChildrenData, setParentData } from '../../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const isCheckedRecursive = (elementId, groupElement, name) => {
  if (!groupElement) return false;
  if (groupElement.value === elementId) return true;
  if (groupElement.children) {
    return Object.values(groupElement.children).some((child) => isCheckedRecursive(elementId, child));
  }

  return false;
};

function removeElementFromGroup(groupElement, elementId) {
  if (!groupElement) return undefined;

  // Recorremos todas las claves del objeto principal
  const newGroup = Object.entries(groupElement)
    .map(([key, valueObj]) => {
      if (key === elementId) return null; // Eliminamos el nodo si la clave coincide
      // Si tiene hijos, procesamos recursivamente
      let newChildren = valueObj.children ? removeElementFromGroup(valueObj.children, elementId) : undefined;
      return [
        key,
        {
          ...valueObj,
          ...(newChildren ? { children: newChildren } : {})
        }
      ];
    })
    .filter(Boolean);

  return Object.fromEntries(newGroup);
}

const AssesmentArea = ({
  name,
  element,
  elementData,
  childrenElements = [],
  form,
  errors,
  onChange,
  parent,
  isPreview,
  elementForm,
  groupElement,
  onClear
}) => {
  const value = form?.[element?.elementStructureId]?.value || '';
  const dataSelected = childrenElements?.find((item) => item._id === value);

  // Determina si el checkbox debe estar marcado
  const checked = isCheckedRecursive(value, groupElement?.[element?.elementStructureId], elementData?.name);
  const isCheckedSubElementId = elementForm?.[name]
    ? elementForm?.[name] === dataSelected?._id || false
    : false;
  if (isPreview && !dataSelected) return null;

  return (
    <>
      {name === 'elementId' ? (
        <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
          {elementData?.name}
        </Typography>
      ) : (
        <FormControlLabel
          control={
            <Checkbox
              color='primary'
              // checked={elementForm?.[name] ? elementForm?.[name] === dataSelected?._id || false : false}
              checked={checked}
              name='subElementId'
              size='small'
              onChange={() => onChange('subElementId', dataSelected?._id)}
            />
          }
          style={{ margin: 0, justifyContent: 'flex-start' }}
          label={
            <div className='flex items-center'>
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                {elementData?.name}
              </Typography>
              {isCheckedSubElementId && (
                <Tooltip arrow title='This is the selected sub-element for the report'>
                <span children='*' className='text-xl font-bold text-secondary ml-2' />
                </Tooltip>
              )}
            </div>
          }
        />
      )}
      <div className='col-span-3'>
        {isPreview ? (
          <Typography>{childrenElements?.find((item) => item._id === value)?.name || ''}</Typography>
        ) : (
          <SelectField
            id={`${element?.elementStructureId}`}
            name={element?.elementStructureId}
            className='capitalize'
            error={errors?.[name]}
            helperText={errors?.[name]}
            value={value}
            onChange={(e) => onChange(element?.elementStructureId, { value: e.target.value, parent }, name)}
            options={childrenElements?.map((item) => ({ value: item._id, label: item.name })) || []}
            placeholder='Choose an option'
            onClear={name === 'elementId' ? undefined : () => onClear(element?.elementStructureId)}
          />
        )}
      </div>
      {dataSelected?.elements?.map((item) => {
        const elData = elementData?.children?.find((el) => el._id === item.elementStructureId);
        return (
          <AssesmentArea
            key={`${element?.elementStructureId}-${item._id}`}
            element={item}
            childrenElements={item.children}
            form={form[element?.elementStructureId].children}
            errors={errors}
            onChange={onChange}
            elementData={elData}
            parent={setParentData({ _id: element?.elementStructureId }, parent)}
            name='subElementId'
            elementForm={elementForm}
            isPreview={isPreview}
            groupElement={groupElement?.[element?.elementStructureId]?.children}
            onClear={onClear}
          />
        );
      })}
    </>
  );
};

const CurriculumData = ({ form = {}, errors = {}, onChange, type, curriculumId, curriculumList = [] }) => {
  const currentCurriculum = curriculumList?.find((item) => item._id === curriculumId);
  const onChangeGroup = (name, value, key) => {
    const formData = setChildrenData(form.groupElement || {}, name, value);
    let elementId = form.elementId;
    let subElementId = form.subElementId;
    if (key === 'elementId') {
      elementId = value?.value;
      subElementId = '';
    } else if (key === 'subElementId') {
      subElementId = value?.value || '';
    }
    delete formData.subElementId;
    onChange('group', {
      elementId,
      subElementId,
      groupElement: formData,
      [key]: value?.value
    });
  };

  const handleRemoveElement = (elementId) => {
    const newGroupElement = removeElementFromGroup(form.groupElement, elementId);
    onChange('group', {
      ...form,
      groupElement: newGroupElement
    });
  };

  return (
    <AssesmentArea
      element={currentCurriculum?.elements}
      elementData={currentCurriculum?.elementsStructure}
      childrenElements={currentCurriculum?.elements?.children}
      form={form.groupElement || {}}
      errors={errors}
      onChange={onChangeGroup}
      name='elementId'
      elementForm={{
        elementId: form.elementId,
        subElementId: form.subElementId
      }}
      isPreview={type === 'preview'}
      groupElement={form.groupElement}
      onClear={handleRemoveElement}
    />
  );
};

const FormCurriculum = ({ form = {}, errors = {}, onChange, type, curriculumList }) => {
  return (
    <>
      <Divider className='col-span-full' />
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Curriculum
      </Typography>
      <div className='col-span-3'>
        <SelectCurriculum
          id='curriculum-level'
          name='curriculumId'
          value={form?.curriculumId}
          onChange={(e) => onChange('curriculumId', e.target.value)}
          error={errors?.curriculumId}
          isPreview={type === 'preview'}
        />
      </div>
      {form?.curriculumId && (
        <CurriculumData
          form={form}
          errors={errors}
          onChange={onChange}
          type={type}
          curriculumId={form.curriculumId}
          curriculumList={curriculumList}
        />
      )}

      <Divider className='col-span-full' />
    </>
  );
};

export default FormCurriculum;
